import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  login(email, password){
    return this.http.post<any>(`${environment.api}auth/login`,{email: email, password: password}, {observe: 'response'} );
  
  }

  getZones(){
    return this.http.get<any>(`${environment.api}auth/zonas`,{});
  }

  getTickets(status){
    if(!status) return this.http.get<any>(`${environment.api}admin/tickets`);
    return this.http.get<any>(`${environment.api}admin/tickets?status=` + status);
  }

  getTicket(id){
    return this.http.get<any>(`${environment.api}admin/ticket/` + id,{});
  }

  getRepuestos(){
    return this.http.get<any>(`${environment.api}admin/repuestos`);
  }
  postZones(zona){
    return this.http.post<any>(`${environment.api}admin/zonas`, { provincia: zona.provincia, localidad: zona.localidad } );
  }


  updatePassword(token, password){
    return this.http.post<any>(`${environment.api}auth/updatePassword`, {token: token, password: password});
  }

  deleteZone(zona){
    return this.http.delete<any>(`${environment.api}admin/zonas/` + zona._id);
  }

  reset_password(email){
    return this.http.post<any>(`${environment.api}auth/reset_password`, {email: email });
  }

  postTicket(ticket){
    return this.http.post<any>(`${environment.api}auth/ticket`, ticket);
  }

  putZone(id, localildad){
    return this.http.put<any>(`${environment.api}admin/zonas/` + id, { localidad: localildad});
  }

  reasignarTicket(ticket, tecnico_nuevo, enviar_whatsapp){
    return this.http.post<any>(`${environment.api}admin/ticket/` + ticket._id+"/reasignar", {id_tecnico: tecnico_nuevo._id, enviar_whatsapp: enviar_whatsapp});
  }

  postTicketComentario(ticket,comentario){
    return this.http.post<any>(`${environment.api}admin/ticket/` + ticket._id+"/comentario", {comentario: comentario});
  }

  getTecnicos(){
    return this.http.get<any>(`${environment.api}admin/tecnicos`);
  }

  getTecnico(id){
    return this.http.get<any>(`${environment.api}admin/tecnico/`+ id);
  }

  postTecnico(tecnico){
    return this.http.post<any>(`${environment.api}admin/tecnico`, tecnico);
  }
  
  updateTecnicoData(id, data){
    return this.http.put<any>(`${environment.api}admin/tecnico/` + id, data);
  }

  agregarZonaATecnico(tecnico, zona){
    return this.http.post<any>(`${environment.api}admin/tecnico/` + tecnico._id+"/zona", {zona: zona});
  }

  setTecnicoMaxTickets(tecnico, count){
    return this.http.post<any>(`${environment.api}admin/tecnico/` + tecnico._id+"/max_tickets", {count: count});
  }

  changePasswordTecnico(tecnico_id, password){
    return this.http.post<any>(`${environment.api}admin/tecnico/${tecnico_id}/changepassword`, {password: password});
  }

  removerZonaTecnico(tecnico,zona){
    return this.http.delete<any>(`${environment.api}admin/tecnico/` + tecnico._id+"/zona/" + zona._id);
  }

  getAdmins(){
    return this.http.get<any>(`${environment.api}admin/admins`);
  }

  createNewAdmin(data){
    return this.http.post<any>(`${environment.api}admin/admins`, data);
  }
  eliminarAdmin(id){
    return this.http.delete<any>(`${environment.api}admin/admins/` + id );
  }

  adminCambiarContraseña(id, password){
    return this.http.put<any>(`${environment.api}admin/admins/` + id + '/password', {password: password} );
  }

  cancelTicket(id){
    return this.http.put<any>(`${environment.api}admin/ticket/` + id + '/cancel', {} );
  }

  putTelefono(id, telefono){
    return this.http.put<any>(`${environment.api}admin/ticket/` + id + '/telefono', { telefono: telefono} );
  }

  enEsperaTicket(id){
    return this.http.put<any>(`${environment.api}admin/ticket/` + id + '/standBy', {} );
  }


  reagendarTicket(id, fecha){
    return this.http.post<any>(`${environment.api}admin/ticket/` + id + '/reagendar', { fecha: fecha} );
  }

  getSoliitudesRepuestos(){
    return this.http.get<any>(`${environment.api}admin/solicitudes_repuestos`);
  }

  nuevaSolicitudRepuestos(tecnico, repuestos){
    return this.http.post<any>(`${environment.api}admin/solicitudes_repuestos/new`, { tecnico: tecnico, repuestos: repuestos} );
  }

  setEnCamino(solicitud) {
    return this.http.put<any>(`${environment.api}admin/solicitudes_repuestos/` + solicitud._id + '/enCamino', {} );
  }

  eliminarTecnico(id){
    return this.http.delete<any>(`${environment.api}admin/tecnico/` + id);
  }

  editAdmin(id, body){
    return this.http.put<any>(`${environment.api}admin/admins/` + id , body );
  }

  getTicketParaCalificar(id){
    return this.http.get<any>(`${environment.api}auth/ticket/` + id );
  }

  calificarTicket(id, body){
    return this.http.post<any>(`${environment.api}auth/ticket/` + id, body );
  }

  agregarRepuestosASolicitud(id, nuevosRepuestos){
    return this.http.put<any>(`${environment.api}admin/solicitudes_repuestos/` + id, nuevosRepuestos );
  }

  cancelarSolicitudRepuestos(id){
    return this.http.put<any>(`${environment.api}admin/solicitudes_repuestos/` + id + "/cancelar", {}) ;
  }

  getAsignaciones(id : String){
    if(id.length<1) return this.http.get<any>(`${environment.api}admin/asignaciones`);
    return this.http.get<any>(`${environment.api}admin/asignaciones/`+id);
  }


  adminTecnicoReview(tecnico, texto, puntos){
    return this.http.post<any>(`${environment.api}admin/tecnico/`+ tecnico + '/review', { text: texto, points: puntos+""});
  }


  adminTicketReview(ticket, texto, puntos){
    return this.http.post<any>(`${environment.api}admin/ticket/`+ ticket + '/review', { text: texto, a: puntos+""});
  }

  validarGarantia(ticket_id){
    return this.http.put<any>(`${environment.api}admin/ticket/`+ ticket_id + '/corroborarGarantia', { status: true });
  }
  getProductos(){
    return this.http.get<any>(`${environment.api}auth/productos`);
  }

  getProductRepuestos(product_id){
    return this.http.get<any>(`${environment.api}auth/productos/` + product_id + "/repuestos");
  }



  updateProducto(_id, nombre, codigo, barcode){
    return this.http.put<any>(`${environment.api}admin/producto/`+ _id , { nombre: nombre, codigo: codigo, barcode: barcode });
  }

  postProducto(nombre, codigo, barcode){
    return this.http.post<any>(`${environment.api}admin/producto`, { nombre: nombre, codigo: codigo, barcode: barcode });
  }

  postRepuesto(repuesto){
    return this.http.post<any>(`${environment.api}admin/repuesto`, repuesto );
  }

  deleteRepuesto(id){
    return this.http.delete<any>(`${environment.api}admin/repuesto/` + id);
  }

  updateProductoDelTicket(ticket_id, producto){
    return this.http.put<any>(`${environment.api}admin/ticket/`+ ticket_id + `/producto`, producto);
  }

  updateGarantiaDelTicket(ticket_id, nuevaGarantia){
    return this.http.put<any>(`${environment.api}admin/ticket/`+ ticket_id + `/garantia`, { codigo: nuevaGarantia });
  }

  deleteProducto(id){
    return this.http.delete<any>(`${environment.api}admin/producto/` + id);
  }

  getFallas(){
    return this.http.get<any>(`${environment.api}admin/fallas`);
  }

  postFallas(falla){
    return this.http.post<any>(`${environment.api}admin/falla`, falla);
  }

  putFallas(falla){
    return this.http.put<any>(`${environment.api}admin/falla`, falla);
  }

  deleteFalla(id){
    return this.http.delete<any>(`${environment.api}admin/falla/` + id);
  }

  postFallasPrecioMasiva(body){
    return this.http.post<any>(`${environment.api}admin/fallasMasiva`, body);
  }

  getTecnicosCsv(){
    return this.http.get<any>(`${environment.api}admin/tecnicoscsv`);
  }

  getProductosCsv(){
    return this.http.get<any>(`${environment.api}admin/productoscsv`);
  }

  getRepuestosCsv(){
    return this.http.get<any>(`${environment.api}admin/repuestoscsv`);
  }

  getSolicitudRepuestosCsv(desde,hasta){
    return this.http.get<any>(`${environment.api}admin/solicitudrepuestoscsv?desde=`+desde+"&hasta=" + hasta);
  }

  getTicketsCsv(desde,hasta,filtro){
    return this.http.get<any>(`${environment.api}admin/ticketscsv?desde=`+desde+"&hasta=" + hasta + "&filtro=" + filtro);
  }

  getFallasCsv(desde,hasta,filtro){
    return this.http.get<any>(`${environment.api}admin/fallascsv?desde=`+desde+"&hasta=" + hasta + "&filtro=" + filtro);
  }
  
  getModificacionesTecnicos() {
    return this.http.get<any>(`${environment.api}admin/modificacionesTecnicos`);
  }

  aceptarModificacionesTecnicos(id){
    return this.http.post<any>(`${environment.api}admin/modificacionesTecnicos/` + id + '/aceptar', {});
  }

  rechazarModificacionesTecnicos(id){
    return this.http.post<any>(`${environment.api}admin/modificacionesTecnicos/` + id + '/rechazar', {});
  }


  reenviarMailPedido(id){
    return this.http.post<any>(`${environment.api}admin/email_pedido`, { id: id});
  }

  getConfig(){
    return this.http.get<any>(`${environment.api}admin/config`);
  }

  postConfig(config){
    return this.http.post<any>(`${environment.api}admin/config`,config);
  }

  testWhatsapp(phone, name){
    return this.http.post<any>(`${environment.api}admin/config/testwhatsapp`,{ phone: phone, name: name});
  }

  agregarCostoAsociadoATicket(ticket_id,item, value){
    return this.http.post<any>(`${environment.api}admin/costo/` + ticket_id, {item: item, value: value});
  }

  eliminarCostoAsociadoATicket(ticket_id, id){
    return this.http.post<any>(`${environment.api}admin/costo/` + ticket_id + '/eliminar', { id: id});
  }


  generarPedidoDeRepuestosPorUtilizadosEnElTicket(ticket_id){
    return this.http.post<any>(`${environment.api}admin/generarSolicitudDeUtilizados/` + ticket_id, { id: ticket_id});
  }


  //**** */

  eliminarTodasLasAsignaciones(){
    return this.http.delete<any>(`${environment.api}admin/eliminar/asignaciones`);
  }


  eliminarTodosLosTickets(){
    return this.http.delete<any>(`${environment.api}admin/eliminar/tickets`);
  }

  eliminarTodasLasSolicitudes(){
    return this.http.delete<any>(`${environment.api}admin/eliminar/solicitudes`);
  }

  importacionMasivaProductosRepuestos(actualizaciones){
    return this.http.post<any>(`${environment.api}admin/importacionMasivaProductos`, { actualizaciones: actualizaciones});
  }

  getWhatsappMessages(page,filtro){
    if(!filtro || filtro.length==0) return this.http.get<any>(`${environment.api}admin/whatsapp_messages?page=${page}`);
    return this.http.get<any>(`${environment.api}admin/whatsapp_messages?page=${page}&filter=${filtro}`);
  }

  finalizarTicket(ticket_id, data){
    return this.http.post<any>(`${environment.api}admin/tickets/${ticket_id}/finalizar`, data);
  }
  
  getWhatsappQueued(){
    return this.http.get<any>(`${environment.api}admin/48horasschedulled`);
  }


  toggle_ticket_whatsapp(ticket_id,value) {
    return this.http.post<any>(`${environment.api}admin/tickets/${ticket_id}/whatsapp`, { value: value});
  }
  
  retry48(ticket_id){
    return this.http.post<any>(`${environment.api}admin/retry48`, { id: ticket_id});
  }

}
